import React from 'react';
import { View } from '@smarterservices/smarter-ui';
import { usePlayerStore } from '../../../stores/StoreContext';
import PlaybackComplete from './PlaybackComplete';
import PlaybackCover from './PlaybackCover';
import LiveLoadingCover from './LiveLoadingCover';
import SeekingLoader from './SeekingLoader';
import Buffering from './Buffering';
import CONSTANTS from '../../../config/constants';

const Overlays = () => {
  const overlay = usePlayerStore((state) => state.overlay);
  const isLive = usePlayerStore((state) => state.isLive);
  const isSeeking = usePlayerStore((state) => state.isSeeking);

  return (
    <View as="div" width="100%" height="100%">
      {overlay === CONSTANTS.OVERLAYS.PLAYBACK_COMPLETE && !isLive && <PlaybackComplete />}
      {overlay === CONSTANTS.OVERLAYS.PLAYBACK_COVER && !isLive && <PlaybackCover />}
      {overlay === CONSTANTS.OVERLAYS.LIVE_LOADING_COVER && !isLive && <LiveLoadingCover />}
      {overlay === CONSTANTS.OVERLAYS.BUFFERING && !isLive && <Buffering />}
      {isSeeking && !isLive && <SeekingLoader />}
    </View>
  );
};

export default Overlays;
